import { NotificationAlert, Table } from '../../../components';
import { assignedMenteesAnnualColumns } from './Column';
import { useEffect, useRef, useState } from 'react';
import {
  annualReviewStatuses,
  statusColors,
  statusesLabel,
} from '../../../helper';
import dayjs from 'dayjs';
import {
  getAllAnnualReviewCycleUsers,
  getAnnualCycleById,
} from '../../../services/annualServices';
import { AnnualReviewUsers } from '../../../types/AnnualReview';
import { userAtom } from '../../../store/atom';
import { useAtomValue } from 'jotai';

const AssignedMenteesAnnual = () => {
  const { cycleId } = useAtomValue(userAtom);
  const myRef = useRef<any>();
  const [annualReviewData, setAnnualReviewData] = useState({
    'Start Date': '-',
    'End Date': '-',
    'Mentor Deadline': '-',
    Name: '',
  });
  const [data, setData] = useState<AnnualReviewUsers[]>([]);
  const [loading, setLoading] = useState(true);

  // fetch quarter details
  const fetchAnnualCycleReviewData = async () => {
    const { data, error } = await getAnnualCycleById(cycleId, 'mentor');
    if (error) return myRef.current?.call('error', error?.message);
    const status = annualReviewStatuses[data?.status || 0];
    setAnnualReviewData({
      'Start Date': dayjs(data?.startDate).format('MMM DD YYYY'),
      'End Date': dayjs(data?.endDate).format('MMM DD YYYY'),
      'Mentor Deadline': dayjs(data?.mentorDeadline).format('MMM DD YYYY'),
      [status]: data?.progress,
      Name: data?.name || '',
    });
  };

  // fetch quarter users
  const fetchAnnualCycleUsers = async () => {
    setLoading(true);
    const { data, error } = await getAllAnnualReviewCycleUsers(
      cycleId,
      'mentor'
    );
    setLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    if (data) setData(data);
  };

  useEffect(() => {
    fetchAnnualCycleReviewData();
    fetchAnnualCycleUsers();
  }, []);

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="text-[20px] font-[500] p-[10px]">
        {annualReviewData?.Name}
      </div>
      <div className="flex gap-x-[10px] p-[10px]">
        {Object.entries(annualReviewData).map((value, idx: number) => {
          if (value[0] === 'Name') return null;
          if (statusesLabel[value[0]]) {
            return (
              <div
                key={idx}
                style={{ background: `${statusColors[value[0]] || ''}` }}
                className="flex flex-col gap-y-1 rounded-[5px] text-white p-[10px]"
              >
                <div>{statusesLabel[value[0]]}</div>
                <div className="text-base font-bold">{`${value[1]}% Complete`}</div>
              </div>
            );
          }
          return (
            <div className="flex flex-col gap-y-1 p-[10px]" key={idx}>
              <div className="opacity-50">{value[0]}</div>
              <div className="opacity-85">{value[1]}</div>
            </div>
          );
        })}
      </div>
      <Table
        columns={assignedMenteesAnnualColumns()}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey={(data) => data.userId}
      />
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AssignedMenteesAnnual;
